import React, { useState, useEffect } from "react";
import { Form, Select } from "antd";
import { useDispatch } from "react-redux";
import { update } from "../../../store/features/orders/createSlice";
import axios from "../../../services/axiosConfig";
import Helper from "../../../services/Helper";

const CustomerDetails = () => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const [shopesList, setShopsList] = useState([]);
  var role = Helper.UserRole();

  useEffect(() => {
    try {
      (async () => {
        const shopDetails = await axios
          .get("/all-shops", {
            params: {
              role,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (shopDetails && shopDetails.data) {
          setShopsList(shopDetails.data.data);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, []);

  return (
    <Form
      layout={"vertical"}
      style={{
        maxWidth: 400,
      }}
      labelCol={{
        span: 6,
      }}
    >
      <Form.Item
        label="Shop"
        name="shop"
        rules={[
          {
            required: true,
            message: "Shop is required",
          },
        ]}
      >
        <Select
          showSearch
          defaultValue="All"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          onChange={(input, option) => {
            dispatch(update({ userId: input }));
            dispatch(update({ priceType: option.priceType }));
            dispatch(update({ points: Number(option.points) }));
          }}
        >
          {shopesList.map((i) => (
            <Option
              key={i.id}
              value={i.id}
              priceType={i.priceType}
              points={i.points}
            >
              {i.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default CustomerDetails;
